export class SafeSessionStorage {
    static getItem(key) {
        try {
            return window.sessionStorage.getItem(key);
        }
        catch {
            return null;
        }
    }
    static setItem(key, value) {
        try {
            window.sessionStorage.setItem(key, value);
            return true;
        }
        catch {
            return false;
        }
    }
    static removeItem(key) {
        try {
            window.sessionStorage.removeItem(key);
            return true;
        }
        catch {
            return false;
        }
    }
    static clear() {
        try {
            window.sessionStorage.clear();
            return true;
        }
        catch {
            return false;
        }
    }
}
//# sourceMappingURL=sessionStorage.js.map